
Checkout.BillShip = function(checkout) {
	var billship = this;

	this.saved = true;

	this.valid =
	this.$disabledMsg =
		false;

	this.$wrap = $('#billandshipinfowrapper');
	this.$anchor = $('a[name=billship]');
	this.$error = $('#billship-error');
	this.$errorMsg = this.$error.find('.msg-text');
	this.$disabledOverlays = this.$wrap.find('.disabled-overlay');

	this.$login = $('#billship-login');
	// remember me?
	this.$rememberMe = $('.billship-remember-me');

	this.$inputFields = $('#billandshipinfowrapper input, #billandshipinfowrapper select');

	this.$verifyEmailWrap = $('#verify-email-wrap');
	this.$verifyEmail = $('#verify_email');

	this.$copyBilling = $('#copy_billing');
	this.$shippingWrap = $('.shipinfo');
		
	this.$billShipHeading = $('#billShipHeading');
	this.$billinfoformzipwrapper = $('.billinfoform .zip_container_wrapper');
	this.$billinfoheading = $('.billinfoheading');

	this.$companyShows = {
		'billing'  : $('#billing_company_show'),
		'shipping' : $('#shipping_company_show')
	};

	this.$companyWraps = {
		'billing'  : $('#billing_company_wrap'),
		'shipping' : $('#shipping_company_wrap')
	};

	this.$addtlPhonesShow = $('#billing_phone_addtl_show');
	this.$addtlPhones = $('.billing_phone_addtl');

	this.$billingError = $('.cart-billing-info-warning');
	this.$billingErrorMsg = this.$billingError.find('.msg-text');

	this.$shippingError = $('.cart-shipping-info-warning');
	this.$shippingErrorMsg = this.$shippingError.find('.msg-text');

	this.$billing = {
		'email': $('#email'),
		'company': $('#billing_company'),
		'firstname': $('#billing_firstname'),
		'lastname': $('#billing_lastname'),
		'address1': $('#billing_address1'),
		'address2': $('#billing_address2'),
		'city': $('#billing_city'),
		'state': $('#billing_state'),
		'country': $('#billing_country'),
		'zip': $('#billing_zip'),
		'phone': $('#billing_phone'),
		'phone_alternate': $('#billing_phone_alternate'),
		'phone_fax': $('#billing_phone_fax')
	};

	this.$shipping = {
		'company': $('#shipping_company'),
		'firstname': $('#shipping_firstname'),
		'lastname': $('#shipping_lastname'),
		'address1': $('#shipping_address1'),
		'address2': $('#shipping_address2'),
		'city': $('#shipping_city'),
		'state': $('#shipping_state'),
		'country': $('#shipping_country'),
        'taxCode': $('#shipping_taxCode'),
		'zip': $('#shipping_zip'),
	};

	this.zipRequired = {
		'billing'  : true,
		'shipping' : true
	};

	this.stateRequests = {
		'billing': false,
		'shipping': false
	};

	this.suggestStates = {};

	this.init = function() {
		billship.listen();
	};

	this.listen = function() {

		billship.$login.click(function() {
			if (billship.$disabledMsg)
				billship.showDisabledMsg();
			else
				billship.showLogin();
		});

		billship.$inputFields.focus(function() {
			billship.removeFieldError($(this));
		});

		billship.$inputFields.change(function() {
			billship.saved = false;
		});

		billship.$billing.country.change(function() {
			billship.getStates('billing');
		});

		$(checkout.config.zipContainer).click(function() {
			$('html,body').animate(
				{ 'scrollTop': checkout.cart.$anchor.offset().top },
				500
			);
			$('#cart-zip').focus();
		});

		billship.$shipping.zip.change(function() {
			billship.checkMatchingZipCode();
		});

		billship.$shipping.city.change(function() {
			billship.checkMatchingZipCode();
		});

		billship.$billing.zip.change(function() {
			billship.checkMatchingZipCode();
		});

		billship.$billing.city.change(function() {
			billship.checkMatchingZipCode();
		});

		billship.$copyBilling.change(function() {
			$('.tooltip-arrow').hide();
			$('.tooltip-inner').hide();
			billship.changeCopyBilling();
			if (billship.$copyBilling.prop('checked') && (checkout.cart.shipping.$zip.val() != billship.$billing.zip.val())) {
				checkout.cart.shipping.$zip.val(billship.$billing.zip.val());
				checkout.cart.shipping.calc(false, true);
			}
		});

		$.each(Object.keys(billship.$companyShows), function(i, section) {
			billship.$companyShows[section].find('button').click(function() {
				billship.showCompany(section);
			});
		});

		billship.$addtlPhonesShow.click(billship.showAddtlPhones);

		billship.$disabledOverlays.click(function() {
			if (billship.$disabledMsg)
				billship.showDisabledMsg();
		});

		// listen for cart content changes

		checkout.cart.$wrap.on('loadDone', function() {
			billship.overrideShipping();
			billship.changeCopyBilling();
			$("label[for='shipping_zip']").html($('#cart-zip')[0].value);
		});

		checkout.cart.$wrap.on('loadFail', function(e) {
			billship.$wrap.hide();
		});

	};

	this.buildContent = function() {
		billship.toggleLoginButton();
		billship.toggleEmail();
		billship.prefillForm();
		billship.removeFieldErrors();
		billship.$wrap.show();
	};

	this.checkMatchingZipCode = function() {

		var session = checkout.session.get();
		if (checkout.session.isLoggedIn()) {
			if (billship.$shipping.zip.val() != session.shipping_zip_original && billship.$shipping.city.val() == session.shipping_city_original) {
				billship.$shippingErrorMsg.html('Please verify your full shipping address above  The zip code entered in the shopping cart above is different than the stored shipping zip code for your account.');
				billship.$shippingError.show();
				billship.$shipping.city.addClass("alert-warning");
				billship.$shipping.state.addClass("alert-warning");
				billship.$shipping.zip.addClass("alert-warning");
			} else {
				billship.$shippingError.hide();
				billship.$shippingErrorMsg.html('');
				billship.$shipping.city.removeClass("alert-warning");
				billship.$shipping.state.removeClass("alert-warning");
				billship.$shipping.zip.removeClass("alert-warning");
			}

			if (billship.$billing.zip.val() != session.billing_zip_original && billship.$billing.city.val() == session.billing_city_original) {
				billship.$billingErrorMsg.html('Please verify your full billing address above.  The zip code entered in the shopping cart above is different than the stored billing zip code for your account.');
				billship.$billingError.show();
				billship.$billing.city.addClass("alert-warning");
				billship.$billing.state.addClass("alert-warning");
				billship.$billing.zip.addClass("alert-warning");
			} else {
				billship.$billingError.hide();
				billship.$billingErrorMsg.html('');
				billship.$billing.city.removeClass("alert-warning");
				billship.$billing.state.removeClass("alert-warning");
				billship.$billing.zip.removeClass("alert-warning");
			}
		} else {
			billship.$shippingError.hide();
			billship.$shippingErrorMsg.html('');
			billship.$shipping.city.removeClass("alert-warning");
			billship.$shipping.state.removeClass("alert-warning");
			billship.$shipping.zip.removeClass("alert-warning");

			billship.$billingError.hide();
			billship.$billingErrorMsg.html('');
			billship.$billing.city.removeClass("alert-warning");
			billship.$billing.state.removeClass("alert-warning");
			billship.$billing.zip.removeClass("alert-warning");
		}
	};

	this.stepTo = function() { 
		var scrollTime = 500;
		if (checkout.session.get('step') == 'shipping')
			checkout.session.set({
				'step': 'billship'
			});

		var section;
		var scrollTo = billship;
		if ( checkout.session.get('step') == 'payment' ) {
			if (!checkout.payment)
				checkout.payment = new Checkout.Payment(checkout);
			scrollTo = checkout.payment;
			checkout.payment.buildContent(true);
		}
		if ( checkout.session.get('step') == 'payment' && checkout.session.get('PayPalConfirmed') )
			return;
		if ( checkout.session.get('step') == 'billship' && checkout.payment) {
			scrollTo = checkout.payment;
			checkout.payment.buildContent(true);
		}
			
		$('html,body').animate(
			{ 'scrollTop': scrollTo.$anchor.offset().top },
			scrollTime
		);
	};

	this.disable = function($disabledMsg) {
		billship.$disabledMsg = $disabledMsg;
		billship.$disabledOverlays.show();
	};

	this.showDisabledMsg = function() {

		billship.error(billship.$disabledMsg.clone(true));

		$('html,body').animate(
			{ 'scrollTop': billship.$anchor.offset().top },
			500
		);

	};

	this.enable = function() {
		billship.$disabledMsg = false;
		billship.$disabledOverlays.hide();
		billship.toggleEmail();
		billship.error(false);
	};

	this.toggleLoginButton = function() {
		// add code to show / hide the remember me button here
		if (checkout.session.isLoggedIn()) {
			billship.$rememberMe.hide();
			billship.$login.hide();
		} else {
			billship.$login.show();
			billship.$rememberMe.show();
		}
	};

	this.toggleEmail = function() {

		if (
			checkout.session.isLoggedIn()
			|| checkout.session.get('PayPalConfirmed')
		) {
			// billship.$billing.email.attr('disabled', 'disabled');
			if (!(checkout.config.isEndeca))
				billship.$verifyEmailWrap.hide();
		} else {
			billship.$billing.email.removeAttr('disabled');
			if (!(checkout.config.isEndeca))
				billship.$verifyEmailWrap.show();
		}

	};

	this.showLogin = function() {

		checkout.login.$wrap.show();

		billship.$wrap.hide();

		if (checkout.payment) {
			checkout.payment.hide();
		}

		$('html,body').animate(
			{ 'scrollTop': checkout.login.$anchor.offset().top },
			500
		);
	};

	this.toggleZipRequired = function(section, required) {
		var $zip = billship['$'+section].zip;
		var cartZip = $('#cart-zip')[0].value;

		billship.zipRequired[section] = required;

		if (required) {
			if ( section == 'billing') {
				if ( !($zip.val().trim()) ) {
					$zip.attr('placeholder', cartZip );
					$zip.val( cartZip );
				}
			} else {
				$zip.attr('placeholder', cartZip );
				$zip.val( cartZip );
			}
		} else {
			$zip.attr('placeholder', 'Zip Code');
		}

		billship.removeFieldError($zip);

	}

	this.overrideShipping = function(forceLoadStates) {
		var origCountry = billship.$shipping.country.val();

		billship.$shipping.country.val(checkout.session.get('shipping.country'));
		billship.$shipping.zip.val(checkout.session.get('shipping.zip'));
		billship.checkMatchingZipCode();

		var $countryOption = billship.$shipping.country.find('option:selected');

		billship.toggleZipRequired(
			'shipping',
			Boolean(parseInt($countryOption.attr('data-ziprequired')))
		);

		if (
			forceLoadStates
			|| origCountry != checkout.session.get('shipping.country')
		) {
			var shippingState = checkout.session.get('shipping.state');
			if (checkout.user && !shippingState) {
				if ( (origCountry == checkout.session.get('shipping.country')) && checkout.session.get('shipping_state_original') ) {
					shippingState = checkout.session.get('shipping_state_original');
				}
			}
			billship.getStates('shipping', shippingState);
		}

	};

	this.prefillForm = function() { 
		var session = checkout.session.get(),
			billing = session.billing,
			shipping = session.shipping,
			copyBilling = Boolean(session.copy_billing);

		if (
			!copyBilling
			&& billship.canCopyBilling(billing, shipping)
		) {
			copyBilling = true;
            billship.setSessionData();
        }

		billship.overrideShipping(true);
        // fill in billing zip if paypal confrimed payment
		if (!billing['zip'] && shipping['zip'] && session.PayPalConfirmed) 
			billing['zip'] = shipping['zip'];

        // the correct location for phone is shipping, not billing, copy shipping
        // phone to billing phone for display 
        // MAYBETODO make this field a shipping field instead of a billing field (move right)
        if (!billing['phone']) 
            billing['phone'] = shipping['phone'];

		for (var field in billship.$billing) {
			if (billing[field]) {

				billship.$billing[field].val(billing[field]);

				if (field == 'company')
					billship.showCompany('billing');
				else if (
					field == 'phone_alternate'
					|| field == 'phone_fax'
				)
					billship.showAddtlPhones();

			} else if (field == 'country') {
				// Default billing.country to United States
				billship.$billing[field].val('US');
			} else {
				if (billship.$billing[field].prop('tagName').toUpperCase() == 'SELECT') {
					var options = billship.$billing[field].children();
					options.removeAttr('selected');
					options.first().attr('selected', 'selected');
				} else
					billship.$billing[field].val('');
			}
		}

		if (copyBilling) {
			billship.$copyBilling.prop('checked', true);
			billship.$shippingWrap.hide();
			$('body').addClass('ecsExpress');
			if (checkout.config.isEndeca) {
				billship.$billShipHeading.show();
				billship.$billinfoheading.hide();
				billship.$billinfoformzipwrapper.show();
			}
		} else {
			billship.$copyBilling.prop('checked', false);
			billship.$shippingWrap.show();
			$('body').removeClass('ecsExpress');
			if (checkout.config.isEndeca) {
				billship.$billinfoheading.show();
				billship.$billinfoformzipwrapper.hide();
				billship.$billShipHeading.hide();
			}
		}

		billship.getStates('billing', billing.state);

		for (var field in billship.$shipping) {

			if (
				field == 'country'
				|| field == 'zip'
			)
				continue;

			if (shipping[field]) {
				billship.$shipping[field].val(shipping[field]);

				if (field == 'company')
					billship.showCompany('shipping');

			} else {
				if (billship.$shipping[field].prop('tagName').toUpperCase() == 'SELECT') {
					var options = billship.$shipping[field].children();
					options.removeAttr('selected');
					options.first().attr('selected', 'selected');
				} else
					billship.$shipping[field].val('');
			}
		}

		billship.changeCopyBilling();
		billship.checkMatchingZipCode();

		return true;
	};

    this.setTaxCodeVisibility = function() {
		var session = checkout.session.get();
		var copyBilling = Boolean( session.copy_billing );
    
        var $taxCode = billship.$shipping.taxCode;
        var $taxCodeContainer = $taxCode.closest( ".infoItem" );
        var country = billship.$shipping.country.val();
        if ( country == "BR" ) {
            $taxCodeContainer.show();
        }
        else {
            $taxCode.val( "" );
            $taxCodeContainer.hide();
        }
    };

	this.showCompany = function(section) {
		billship.$companyShows[section].hide();
		billship.$companyWraps[section].show();
	}

	this.showAddtlPhones = function() {
		billship.$addtlPhonesShow.hide();
		billship.$addtlPhones.show();
	}

	// Determines if the "Ship to Billing Address" check-box can be pre-checked
	this.canCopyBilling = function(billing, shipping) {
		var fieldsDiff = [],
			allowEmptyBillingFields = {
				'country' : 1,
				'state'   : 1,
				'zip'     : 1
			};

		// Clone the input for local modifications
		billing = $.extend({}, billing);
		shipping = $.extend({}, shipping);

		$.each(Object.keys(shipping), function(i, field) {

			billing[field] = (billing[field] || '').trim().toUpperCase();
			shipping[field] = (shipping[field] || '').trim().toUpperCase();

			if (billing[field] != shipping[field])
				fieldsDiff.push(field);

		});

		// No difference in addresses
		if (!fieldsDiff.length)
			return true;

		if (
			$.map(fieldsDiff, function(field) {

				if (
					!allowEmptyBillingFields[field]
					|| billing[field]
				)
					return false;

			}).length
		)
			return false;

		return true;
	}

	this.getStates = function(section, selectState) {
		var $stateSelect = billship['$'+section].state,
			$countryOption = billship['$'+section].country.find('option:selected'),
			country = $countryOption.val();

		billship.toggleZipRequired(
			section,
			Boolean(parseInt($countryOption.attr('data-ziprequired')))
		);

		if (billship.stateRequests[section])
			billship.stateRequests[section].abort();

		$stateSelect
			.show()
			.attr('disabled', 'disabled')
			.html('<option value="">Loading States...</option>');

		if (!country) {
			$stateSelect.hide();
			return;
		}

		billship.stateRequests[section] = checkout.remote.call({
			'cache': true,
			'data': {
				'step': 'billship',
				'action': 'getStates',
				'country': country
			}
		})
			.done(function(response) {
				billship.buildStates(section, response.data, selectState);
                var stateRequestValues = Object.keys(billship.stateRequests).map(function(k) {
                    return billship.stateRequests[k]
                });
                    if (stateRequestValues.filter(function(request) { 
						if (request && request.state) {
							return request.state() == 'resolved';
						} else 
							return;
					}).length == 2)  {
					// make this a callback so that the html changes in buildStates have had time to propagate through the dom
					setTimeout( function() {
						billship.verifySteps( section, checkout.session.get('step'), checkout.session.get('PayPalConfirmed') );
					}, 0);
				}
			})
			.fail(function(request) {

			});
	};

	this.verifySteps = function( section, checkoutStep, paypalConfirmed ) {
		var firstInvalidStep;
		if (checkoutStep == 'payment' && paypalConfirmed) {
			$.each( checkout.steps, function( i, step ) {
				if (checkoutStep == step)
					return;
				if (!checkout[step]) {
					firstInvalidStep = step;
					return;
				}
				if (checkout[step].validate && !checkout[step].validate() && !firstInvalidStep)
					firstInvalidStep = step;
			});
		}
		if (firstInvalidStep) {
			if (firstInvalidStep == 'login')
				firstInvalidStep = 'billship';
			checkout.scrollToInvalidStep(checkout[firstInvalidStep]);
		} else {
			if (!checkout.payment) {
				checkout.payment = new Checkout.Payment( checkout );
				checkout.payment.buildContent(true);
			}
			if (paypalConfirmed) {
				var scrollTo = checkout.payment;
				var scrollTime = 500;
				$('html,body').animate(
					{ 'scrollTop': scrollTo.$anchor.offset().top },
					scrollTime
				);
			}
		}
	}

	this.buildStates = function(section, states, selectState) { 
		selectState = selectState || billship.suggestStates[section];

		var $stateSelect = billship['$'+section].state,
			options = [
				'<option value="">* Select State/Province/Territory</option>'
			];

		if (!states.length) {
			$stateSelect.hide();
			return;
		}

		$.each(states, function(i, state) {
			options.push(
				'<option value="'+state.state+'">'
					+ state.name
				+ '</option>'
			);
		});

		$stateSelect
			.removeAttr('disabled')
			.html(options);

		if (selectState)
			$stateSelect.val(selectState);
	};

	this.changeCopyBilling = function() {
		if (billship.$copyBilling.prop('checked')) {
			billship.$shippingWrap.hide();
			$('body').addClass('ecsExpress');
			if (checkout.config.isEndeca) {
				billship.$billShipHeading.show();
				billship.$billinfoheading.hide();
				billship.$billinfoformzipwrapper.show();
			}

			var countryChanged = false;

			if (
				billship.$billing.country.val()
				!= billship.$shipping.country.val()
			)
				countryChanged = true;

			billship.$billing.country
				.val(billship.$shipping.country.val())
				.attr('disabled', 'disabled');

			if (countryChanged) {
				billship.getStates('billing', billship.$shipping.state.val());
			}

			billship.$billing.zip.attr('disabled', 'disabled');

			billship.checkMatchingZipCode();

		} else {
			billship.$shippingWrap.show();
			$('body').removeClass('ecsExpress');
			if (checkout.config.isEndeca) {
				billship.$billShipHeading.hide();
				billship.$billinfoheading.show();
				billship.$billinfoformzipwrapper.hide();
			}

			billship.$billing.country
				.removeAttr('disabled');

			billship.$shipping.zip.attr('disabled', 'disabled');
			billship.$billing.zip.removeAttr('disabled');

		}

        billship.setTaxCodeVisibility();
	};

	this.getData = function() {
		var rememberMe = 0;
		if ( checkout.session.isLoggedIn() )
			rememberMe = checkout.session.get('rememberMe');
		else
			rememberMe = billship.$wrap.find('#billing_remember_me:visible:checked').length;

		return {
			'copy_billing': ( billship.$copyBilling.prop('checked') ? 1 : 0),
			'rememberMe'  : rememberMe,
			'email': billship.$billing.email.val().trim(),
			'billing': {
				'email': billship.$billing.email.val().trim(),
				'company': billship.$billing.company.val().trim(),
				'firstname': billship.$billing.firstname.val().trim(),
				'lastname': billship.$billing.lastname.val().trim(),
				'address1': billship.$billing.address1.val().trim(),
				'address2': billship.$billing.address2.val().trim(),
				'city': billship.$billing.city.val().trim(),
				'country': billship.$billing.country.val(),
				'zip': billship.$billing.zip.val().trim(),
				'state': billship.$billing.state.val(),
				'phone': billship.$billing.phone.val().replace(/\D/g, ''),
				'phone_alternate': billship.$billing.phone_alternate.val().replace(/\D/g, ''),
				'phone_fax': billship.$billing.phone_fax.val().replace(/\D/g, '')
			},
			'shipping': {
				'company': billship.$shipping.company.val().trim(),
				'firstname': billship.$shipping.firstname.val().trim(),
				'lastname': billship.$shipping.lastname.val().trim(),
				'address1': billship.$shipping.address1.val().trim(),
				'address2': billship.$shipping.address2.val().trim(),
				'city': billship.$shipping.city.val().trim(),
				'state': billship.$shipping.state.val(),
				'phone': billship.$billing.phone.val().replace(/\D/g, ''),
                'taxCode': billship.$shipping.taxCode.val(),
			}
		};
	};

	this.setSessionData = function() {
		checkout.session.set(billship.getData());
	};

	this.validate = function() {

		// destroy all previous errors

		billship.valid = true;
		billship.removeFieldErrors();
		billship.error(false);

		// start new validation

		var data = billship.getData();

		checkout.session.set(data);

		if (
			!checkout.session.isLoggedIn()
			&& !checkout.session.get('PayPalConfirmed')
		) {
			if (!data.billing.email)
				billship.fieldError(billship.$billing.email, 'Required');
			else if (data.billing.email.length < 6)
				billship.fieldError(billship.$billing.email, 'Minimum of 6 characters');
			else if (!isValidEmailAddress(data.billing.email))
				billship.fieldError(billship.$billing.email, 'Valid Email Address Required');

			if (!(checkout.config.isEndeca)) {
				var verifyEmail = billship.$verifyEmail.val().trim();
				if (!verifyEmail)
					billship.fieldError(billship.$verifyEmail, 'Required');
				else if (
					data.billing.email
					&& data.billing.email != verifyEmail
				)
					billship.fieldError(billship.$verifyEmail, 'Must Match Email Address');
			}
		}

		if (!data.billing.firstname)
			billship.fieldError(billship.$billing.firstname, 'Required');

		if (!data.billing.lastname)
			billship.fieldError(billship.$billing.lastname, 'Required');
		else if (data.billing.lastname.length < 2)
			billship.fieldError(billship.$billing.lastname, 'Minimum of 2 characters');

		if (!data.billing.address1)
			billship.fieldError(billship.$billing.address1, 'Required');
		else if (data.billing.address1.length < 4)
			billship.fieldError(billship.$billing.address1, 'Minimum of 4 characters');

		if (!data.billing.city)
			billship.fieldError(billship.$billing.city, 'Required');
		else if (data.billing.city.length < 2)
			billship.fieldError(billship.$billing.city, 'Minimum of 2 characters');

		if (
			billship.zipRequired.billing
			&& !data.billing.zip
		)
			billship.fieldError(billship.$billing.zip, 'Required');

		if (!data.billing.country)
			billship.fieldError(billship.$billing.country, 'Required');

		if (
			(
				data.billing.country == 'US'
				|| data.billing.country == 'CA'
				|| data.billing.country == 'AU'
			)
			&& !data.billing.state
		)
			billship.fieldError(billship.$billing.state, 'Required');

		var minPhoneLength = 7;

		if (
			data.billing.country == 'US'
			|| data.billing.country == 'CA'
		)
			minPhoneLength = 10;

		if (!data.billing.phone)
			billship.fieldError(billship.$billing.phone, 'Valid Phone Number Required');
		else if (data.billing.phone.length < minPhoneLength)
			billship.fieldError(billship.$billing.phone, 'Minimum of '+minPhoneLength+' digits');

		if (!data.copy_billing) {

			if (!data.shipping.firstname)
				billship.fieldError(billship.$shipping.firstname, 'Required');

			if (!data.shipping.lastname)
				billship.fieldError(billship.$shipping.lastname, 'Required');
			else if (data.shipping.lastname.length < 2)
				billship.fieldError(billship.$shipping.lastname, 'Minimum of 2 characters');

			if (!data.shipping.address1)
				billship.fieldError(billship.$shipping.address1, 'Required');
			else if (data.shipping.address1.length < 4)
				billship.fieldError(billship.$shipping.address1, 'Minimum of 4 characters');

			if (!data.shipping.city)
				billship.fieldError(billship.$shipping.city, 'Required');
			else if (data.shipping.city.length < 2)
				billship.fieldError(billship.$shipping.city, 'Minimum of 2 characters');

			var shippingCountry = checkout.session.get('shipping.country');

			if (
				(
					shippingCountry == 'US'
					|| shippingCountry == 'CA'
					|| shippingCountry == 'AU'
				)
				&& !data.shipping.state
			)
				billship.fieldError(billship.$shipping.state, 'Required');

		}

		return billship.valid;
	};

	this.fieldError = function($field, errorMsg) {

		billship.valid = false;

        // for fields which exist in billing but not shipping or vice versa
        if ( ! $field ) return;

		$field
			.addClass('field-error')
			.tooltip({
				'title': errorMsg,
				'html': true,
				'trigger': 'manual'
			})
			.tooltip('show');
	};

	this.fieldErrors = function(errors) {

		if (errors.billing)
			for (var field in errors.billing)
				billship.fieldError(billship.$billing[field], errors.billing[field]);

		if (errors.shipping)
			for (var field in errors.shipping)
				billship.fieldError(billship.$shipping[field], errors.shipping[field]);

	};

	this.removeFieldError = function($field) {
		$field
			.removeClass('field-error')
			.tooltip('dispose');
	};

	this.removeFieldErrors = function() {
		billship.$inputFields
			.removeClass('field-error')
			.tooltip('dispose');
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			billship.$errorMsg.html(errorMsg);
			billship.$error.show();
		} else {
			billship.$error.hide();
			billship.$errorMsg.html('');
		}
	};

	this.init();
};

